import * as React from 'react';
import { AiSummaryModalDesktop } from '../../components/AiSummaryModalDesktop';
import type { IAiSummaryFooterActions } from '../../components/AiSummaryModalDesktop/types';
import type { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { NewbuildingCallButton } from '../NewbuildingCallButton';
import { NewbuildingChatButton } from '../NewbuildingChatButton';

const mockBuilderWithChat: IBuilder = {
  id: 1,
  realtyUserId: 1,
  name: 'Застройщик',
  logoUrl: '',
  chat: {
    enabled: true,
    suggestText: 'Здравствуйте!',
    context: {},
    entityId: '1',
  },
  phone: {
    countryCode: '7',
    code: '495',
    number: '1234567',
  },
};

const mockBuilderWithoutChat: IBuilder = {
  ...mockBuilderWithChat,
  id: 2,
  realtyUserId: 2,
  chat: null,
  phone: {
    countryCode: '7',
    code: '495',
    number: '1111111',
  },
};

const mockAgency: ISeller = {
  realtyUserId: 3,
  name: 'Агентство недвижимости',
  logoUrl: '',
  chat: null,
  phone: {
    countryCode: '7',
    code: '495',
    number: '7654321',
  },
};

interface IMockNewbuildingContacts {
  newbuildingId: number;
  url: string;
  builders: IBuilder[];
  sellers: ISeller[];
}

const mockNewbuildingContacts: IMockNewbuildingContacts[] = [
  {
    newbuildingId: 1,
    url: 'https://www.cian.ru/zhiloy-kompleks-badaevskiy-moskva-348843/',
    builders: [mockBuilderWithChat],
    sellers: [mockAgency],
  },
  {
    newbuildingId: 2,
    url: 'https://www.cian.ru/zhiloy-kompleks-simvol-moskva-348844/',
    builders: [mockBuilderWithoutChat],
    sellers: [],
  },
];

export interface IAiSummaryModalDesktopContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const AiSummaryModalDesktopContainer = ({
  open,
  onOpenChange,
}: IAiSummaryModalDesktopContainerProps): React.JSX.Element => {
  const footerActions: IAiSummaryFooterActions[] = mockNewbuildingContacts.map(newbuilding => {
    const hasChat = [...newbuilding.builders, ...newbuilding.sellers].some(contact => contact.chat?.enabled);

    return {
      newbuildingId: newbuilding.newbuildingId,
      call: (
        <NewbuildingCallButton
          builders={newbuilding.builders}
          newbuildingId={newbuilding.newbuildingId}
          sellers={newbuilding.sellers}
          size="M"
          url={newbuilding.url}
        />
      ),
      chat: hasChat ? (
        <NewbuildingChatButton
          builders={newbuilding.builders}
          newbuildingId={newbuilding.newbuildingId}
          sellers={newbuilding.sellers}
          size="M"
          url={newbuilding.url}
        />
      ) : undefined,
    };
  });

  return <AiSummaryModalDesktop footerActions={footerActions} onOpenChange={onOpenChange} open={open} />;
};
